import styled from '@emotion/styled'
import { Divider, Typography } from '@mui/material'
import { FC } from 'react'
import { BaseChartTooltip } from 'src/components/chart-tooltip'
import { Colors } from 'src/components/theme'
import { formatVal } from 'src/utils/number-format'

const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

const ItemWrapper = styled.div`
  padding: 8px;
`

const ItemLabelWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const Dot = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
`

type BuyVsSellOvertimeChartProps = {
  year: number
  bought: number
  boughtAmount: number
  sold: number
  soldAmount: number
}

type ItemProps = {
  label: string
  value: number
  color: string
  amount: number
  negative?: boolean
}
const Item: FC<ItemProps> = ({ amount, color, label, value, negative }) => {
  return (
    <ItemWrapper>
      <ItemLabelWrapper>
        <Dot style={{ backgroundColor: color }} />
        <Typography color={Colors.neutral400} variant="text1m">
          {label}
        </Typography>
      </ItemLabelWrapper>
      <div>
        <Typography color={Colors.neutral700} variant="text1m">
          {`${negative ? '-' : '+'}${value} properties ($${formatVal(amount, 'number')}) `}
        </Typography>
      </div>
    </ItemWrapper>
  )
}

export const BuyVsSellOvertimeChartTooltip: FC<BuyVsSellOvertimeChartProps> = ({
  bought,
  boughtAmount,
  sold,
  soldAmount,
  year,
}) => {
  return (
    <BaseChartTooltip titleLabel="Date:" title={year}>
      <Content>
        <Item color={Colors.primaryGreen600} label="Bought" value={bought} amount={boughtAmount} />
        <Divider orientation="horizontal" flexItem />
        <Item color={Colors.primaryRed600} label="Sold" value={sold} amount={soldAmount} negative />
      </Content>
    </BaseChartTooltip>
  )
}
